import Column from '@components/Column';
import Skeleton from '@components/Skeleton';
import styled from '@emotion/styled';

function CouponDetailSkeleton() {
    return (
        <Container fullWidth align='center' spacing={4} aria-busy>
            <Skeleton width={264} height={204} shape='block' />
            <Column fullWidth align='center' spacing={2}>
                <Skeleton width={120} height={20} />
                <Skeleton width={160} height={22} />
                <Skeleton width={80} height={22} />
            </Column>
            <Skeleton width={220} height={60} />
        </Container>
    );
}

const Container = styled(Column)`
    padding: var(--spacing-6);
`;

export default CouponDetailSkeleton;
